import * as C from '../../constants';
import defaultState from './defaultState';

export default {
  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_CLEAR](state) {
    Object.assign(state, defaultState());
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_FILTER_LOAD_PENDING](state) {
    state.filter.data = {
      ...state.filter.data,
      loading: true,
      error: false,
      selectedBrands: [],
      selectedDomains: [],
      brands: [],
      domains: [],
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_LOAD_SUCCESS](state, payload) {
    state.filter.data = {
      ...state.filter.data,
      loading: false,
      error: false,
      ...payload,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_FILTER_LOAD_FAILURE](state) {
    state.filter.data = {
      ...state.filter.data,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_LIST_LOAD_PENDING](state) {
    state.tableData = {
      loading: true,
      error: false,
      rows: [],
      stays: [],
    };
    state.filter.lastSearch = {
      performed: true,
      date: { ...state.filter.date },
      data: { ...state.filter.data },
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_LIST_LOAD_SUCCESS](state, payload) {
    state.tableData = {
      ...state.tableData,
      loading: false,
      loaded: true,
      rows: payload,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_LIST_LOAD_FAILURE](state) {
    state.tableData = {
      ...state.tableData,
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, arrivalFromDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, arrivalToDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_PAID_FROM_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, paidDateFromDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_PAID_TO_CHANGE](state, payload) {
    state.filter.date = { ...state.filter.date, paidDateToDate: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_BRANDS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedBrands: payload };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_FILTER_DOMAINS_CHANGE](state, payload) {
    state.filter.data = { ...state.filter.data, selectedDomains: payload };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_LIST_DOWNLOAD_PENDING](state) {
    state.download.list = {
      loading: true,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_LIST_DOWNLOAD_SUCCESS](state) {
    state.download.list = {
      loading: false,
      error: false,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_LIST_DOWNLOAD_FAILURE](state) {
    state.download.list = {
      loading: false,
      error: true,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_PENDING](state, payload) {
    state.download.specifications = {
      loading: true,
      error: false,
      name: payload,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_SUCCESS](state) {
    state.download.specifications = {
      loading: false,
      error: false,
      name: undefined,
    };
  },

  /**
   * @param state
   */
  [C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_FAILURE](state) {
    state.download.specifications = {
      loading: false,
      error: true,
      name: undefined,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payments/clientPayments/mutations.js